import React from 'react';
import VehicleTrackingListMainContent from 'src/components/VehicleTrackingReport/VehicleTrackingListMainContent';

export default function VehicleTrackingList() {
  return <VehicleTrackingListMainContent />;
}
